import { useDialog } from '@shared-ui/dialog-context';
import React from 'react';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkDialog, UitkDialogContent } from 'uitk-react-dialog';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

interface BaseDialogProps {
  dialogId: string;
  dialogLabel: string;
  headerText: string;
  bodyText: string;
  buttonText: string;
  onDialogClose?: () => void;
}

export const BaseDialog: React.FC<BaseDialogProps> = ({
  dialogId,
  dialogLabel,
  headerText,
  bodyText,
  buttonText,
  onDialogClose,
}) => {
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog(dialogId, 'dialog');

  const closeDialog = () => {
    onDialogClose();
    dialogActions.closeDialog();
  };

  return (
    <DialogComponent>
      <UitkDialog ariaLabel={dialogLabel} returnFocusOnClose dialogShow={isDialogOpen}>
        <UitkDialogContent key="dialogContent">
          <UitkLayoutFlex space="two" direction="column">
            <>
              <UitkLayoutFlexItem>
                <UitkHeading tag="h2" size={5} key="dialogHeading">
                  {headerText}
                </UitkHeading>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem alignSelf="center">
                <UitkParagraph key="dialogParagraph" size={2}>
                  {bodyText}
                </UitkParagraph>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <UitkSpacing margin={{ blockstart: 'two' }}>
                  <UitkPrimaryButton onClick={closeDialog}>{buttonText}</UitkPrimaryButton>
                </UitkSpacing>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        </UitkDialogContent>
      </UitkDialog>
    </DialogComponent>
  );
};
